/**
* @ngdoc class
* @name Deferred
*
* @description
* Polyfill for the angular $q.defer()
*/
class Deferred {

    constructor() {

        this.promise = new Promise((resolve, reject) => {

            this.resolve = resolve;
            this.reject = reject;

        });

    }

}

export default Deferred;



// WEBPACK FOOTER //
// ./scripts/common/services/util/-RFC.deferred.js